import type { ClaimPromoCodeResponse , PromoCodeResponse , ValidatePromoCodeResponse } from '../../../types/promo-code.types';

import { promoCodeService } from './promo-codes.instance';

export const validatePromoCode = async (promoCode: string) => {
  const sanitizedPromoCode = promoCode.trim().toUpperCase();

  const response = await promoCodeService.get<ValidatePromoCodeResponse>(
    `/${sanitizedPromoCode}/validate`
  );

  return response.data;
};

export const getPromoCode = async (promoCode: string) => {
  const sanitizedPromoCode = promoCode.trim().toUpperCase();

  const response = await promoCodeService.get<PromoCodeResponse>(
    `/${sanitizedPromoCode}`
  );

  return response.data;
};

export const redeemPromoCode = async (promoCode: string) => {
  const response = await promoCodeService.post<ClaimPromoCodeResponse>(
    `/${promoCode}/redeem`
  );

  return response.data;
};
